export const BASE_URL = 'https://edcat.net/api/edcat';
export const requestOptions = {
	method: 'GET',
	redirect: 'follow'
};